// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zLSME","input":"styles_input__8m-PS"};